import React, { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { Switch, Route, Redirect } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/Sidebar/Sidebar";
import routes from "../routes.js";
import theme from "../theme.js";


const useStyles = makeStyles(() => ({
  mainContainer: {
    marginLeft: (props) => props.drawerWidth,
  },
  innerMainContainer: {
    padding: "15px 24px 10px",
    marginTop: theme.spacing(1),
  },
  sidebar: {
    width: (props) => props.drawerWidth,
  },
}));

const Admin = ({ match }) => {
  const [custom_fullwindow, setcustom_fullwindow] = useState(false);
  const drawerWidth = custom_fullwindow === true ? 72 : 240;
  const classes = useStyles({ drawerWidth });

  const custom_fullwindowData = () => {
    if (custom_fullwindow) {
      setcustom_fullwindow(false);
    } else {
      setcustom_fullwindow(true);
    }
  };
  return (
    <>
      <Sidebar
        routes={routes}
        sidebarWidth={classes.sidebar}
        custom_fullwindow={custom_fullwindowData}
      />
      <div
        className={`${classes.mainContainer} ${custom_fullwindow ? `custom_fullwindow` : ""
          } `}
      >
        <Navbar />
        <Box className={classes.innerMainContainer}>
          <Switch>
            {routes
              .filter((route) => route.role === "organization")
              .map((prop, key) => {
                return (
                  <Route
                    path={`${match.url}/${prop.path}`}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            <Redirect from="/admin" to="/admin/bookings" />
          </Switch>
        </Box>
      </div>
    </>
  );
};

export default Admin;
